import { BasketCookie, getBasketCookie } from 'utils/basket';
import { isUserAuth } from 'utils/cookie';
import { loadBasketRemote } from '../helpers';
import { getCountryHref, dispatchEvent } from 'utils/common';
import { BASKET_EVENT_UPDATE, BASKET_EVENT_UPDATE_SERVICE } from '../consts';
import { getServicesCookie } from '../../../../../utils/services';

const BASKET_PATH = '/basket';
const REMOTE_LOAD_TIMEOUT_MS = 5000;

let loadBasketPromise: Promise<BasketCookie[]> | undefined;

export const cleanCache = () => {
  loadBasketPromise = undefined;
};

const loadBasketWithCache = (): Promise<BasketCookie[]> => {
  loadBasketPromise ??= loadBasketRemote().finally(() => {
      loadBasketPromise = undefined;
  });

  return loadBasketPromise;
};

const loadBasketWithFallback = async () => {
  const fallback = () => getBasketCookie() ?? [];

  let timeoutId: ReturnType<typeof setTimeout>;
  const timeoutPromise = new Promise<BasketCookie[]>(resolve => {
    timeoutId = setTimeout(() => {
      cleanCache();
      resolve(fallback());
    }, REMOTE_LOAD_TIMEOUT_MS);
  });

  try {
    return await Promise.race([loadBasketWithCache(), timeoutPromise]);
  } catch {
    return fallback();
  } finally {
    clearTimeout(timeoutId!);
  }
};

export const handleBasketLoad = async () => {
  const isAuthorized = isUserAuth();
  const path = location.pathname;

  const basket =
    isAuthorized && path.startsWith(getCountryHref(path, BASKET_PATH))
      ? await loadBasketWithFallback()
      : (getBasketCookie() ?? []);
  const services = getServicesCookie() || [];

  dispatchEvent(BASKET_EVENT_UPDATE, basket);
  dispatchEvent(BASKET_EVENT_UPDATE_SERVICE, services);
};
